import { render, staticRenderFns } from "./send_detail_list.vue?vue&type=template&id=0cc68e67&scoped=true&"
import script from "./send_detail_list.vue?vue&type=script&lang=js&"
export * from "./send_detail_list.vue?vue&type=script&lang=js&"
import style0 from "./send_detail_list.vue?vue&type=style&index=0&id=0cc68e67&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc68e67",
  null
  
)

export default component.exports